import React, { useState, useEffect } from 'react';
import '../styles/MenuPage.scss';

function MenuPage() {
    const [data, setData] = useState([]);

    return (
        <div className="web-body">
            <h1>Our Menu:</h1>
        </div>
    );

}

export default MenuPage;
